export function getApplicablePrice({ priceList, selectedUomId, sPriceListId, alternateUom = [], primaryUomId = null }) {
  if (!Array.isArray(priceList) || priceList.length === 0) return null;

  const sortByLatestDate = (arr) =>
    arr
      .map((p) => ({
        ...p,
        effectiveDate: p.effectiveFrom ? new Date(p.effectiveFrom) : null,
      }))
      .sort((a, b) => {
        if (!a.effectiveDate && !b.effectiveDate) return 0;
        if (!a.effectiveDate) return 1;
        if (!b.effectiveDate) return -1;
        return b.effectiveDate - a.effectiveDate;
      });

  // STEP 1: PriceList + UOM + Date
  let step1 = priceList.filter((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.uomId === selectedUomId && p.effectiveFrom);
  if (step1.length > 0) return sortByLatestDate(step1)[0];

  // STEP 2: PriceList + UOM (no date)
  let step2 = priceList.find((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.uomId === selectedUomId && !p.effectiveFrom);
  if (step2) return step2;

  // STEP 3: Alternate UOM — derive price via conversion rate (aligned with Roadmap branch)
  const altUomArr = Array.isArray(alternateUom) ? alternateUom : [];
  if (altUomArr.length > 0 && selectedUomId) {
    const selectedAlt = altUomArr.find((a) => a.csUomId === selectedUomId);
    if (selectedAlt && selectedAlt.convertionRate) {
      const basePrice =
        priceList.find((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.uomId === primaryUomId && !p.effectiveFrom) ||
        priceList.find((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && !p.uomId && !p.effectiveFrom) ||
        sortByLatestDate(priceList.filter((p) => !sPriceListId || p.sPricelistId === sPriceListId))[0];
      if (basePrice) {
        const derivedPricestd = parseFloat((parseFloat(basePrice.pricestd) * parseFloat(selectedAlt.convertionRate)).toFixed(4));
        return { ...basePrice, uomId: selectedUomId, pricestd: derivedPricestd, pricelist: derivedPricestd, _derived: true };
      }
    }
  }

  // STEP 4: PriceList only (latest date)
  let step4 = priceList.filter((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.effectiveFrom);
  if (step4.length > 0) return sortByLatestDate(step4)[0];

  // STEP 5: PriceList only (no date)
  let step5 = priceList.find((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && !p.effectiveFrom);
  if (step5) return step5;

  // STEP 6: Any UOM match (latest date)
  let step6 = priceList.filter((p) => p.uomId === selectedUomId && p.effectiveFrom);
  if (step6.length > 0) return sortByLatestDate(step6)[0];

  // STEP 7: Default (no UOM, no date)
  return priceList.find((p) => !p.uomId && !p.effectiveFrom) || null;
}
